import api from '@/api'
import _ from 'lodash'
import LayoutConverter from '@/libs/layout-converter'

function compareArrays(a,b) {
  for (let i = 0; i < Math.min(a.length, b.length); ++i) {
    if (a[i] != b[i]) {
      return a[i] - b[i];
    }
  }

  return a.length - b.length;
}

export default {
  state: {
    files: {
      extensions: [],
      limits: {}
    }
  },

  mutations: {
    setFilesLimits: (s, data) => {
      s.files.extensions = data.extensions;
      s.files.limits = data.limits;
    }
  },

  getters: {
    getFilesLimits: s => s.files
  },

  actions: {
    async searchDepartment({}, text) {
      try {
        const response = await api.get('system/department/user/auto', {
          params: {
            query: LayoutConverter.en(text),
            query2: LayoutConverter.ru(text),
            //pagesize: 10
          }
        });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          // const levels = {};
          // const sorted = _.sortBy(result || [], ['level', 'name']).map(e => {
          //   levels[e.id] = (levels[e.parentId] || []).concat([e.id]);
          //   e.sortKey = levels[e.id];
          //   return e;
          // });
          //
          // const output = sorted.sort((a, b) => {
          //   return compareArrays(a.sortKey, b.sortKey);
          // });
          // return output;

          const levels = {};
          const sorted = _.sortBy(result || [], ['level', 'name']).map(e => {
            levels[e.id] = (levels[e.parentId] || '') + (e.id + '|');
            e.sortKey = levels[e.id];
            return e;
          });

          const output = sorted.sort((a, b) => a.sortKey.localeCompare(b.sortKey));

          for(let i = 0; i < output.length; ++i) {
            if (i + 1 < output.length && output[i + 1].level > output[i].level) {
              output[i].expandable = true;
              output[i].collapsed = !text;
            }
          }

          return output;
        }
        else {
          console.error('failed searching for departments by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for departments by a filter due to error:', e);
      }
    },

    async searchCategories({}, text) {
      let options = {};

      if (text instanceof Object) {
        options = text;
        text = options.text;
      }

      try {
        const params = {
          query: LayoutConverter.en(text),
          query2: LayoutConverter.ru(text)
        };

        if (options.full) {
          params.full = 1;
          params.pageSize = 4000;
        }
        else {
          params.pageSize = options.pageSize || 4000;
        }

        const response = await api.get('system/category/user/auto', { params });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          const levels = {};
          const sorted = _.sortBy(result || [], ['level', 'name']).map(e => {
            levels[e.id] = (levels[e.parentId] || '') + (e.id + '|');
            e.sortKey = levels[e.id];
            return e;
          });

          const output = sorted.sort((a, b) => a.sortKey.localeCompare(b.sortKey));

          for(let i = 0; i < output.length; ++i) {
            if (i + 1 < output.length && output[i + 1].level > output[i].level) {
              output[i].expandable = true;
              output[i].collapsed = !text;
            }
          }

          return output;
        }
        else {
          console.error('failed searching for categories by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for categories by a filter due to error:', e);
      }
    },

    async searchLotIdentifier({}, text) {
      let options = {};

      if (text instanceof Object) {
        options = text;
        text = options.text;
      }

      let all = false;
      const params = {
        query: LayoutConverter.en(text),
        query2: LayoutConverter.ru(text)
      };

      if (options.all) {
        all = true;
        params.full = true;
        params.pageSize = 4000;
      }
      else {
        params.pageSize = options.pageSize || 4000;
      }

      try {
        const response = await api.get(`lots/num/auto/${all}`, { params });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.num
          }));
        }
        else {
          console.error('failed searching for lot identifiers by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for lot identifiers by a filter due to error:', e);
      }
    },

    async searchPublicLots({}, { text, archive }) {
      try {
        const response = await api.get('lots/auto', {
          params: {
            query: LayoutConverter.en(text),
            query2: LayoutConverter.ru(text),
            pagesize: 10,
            archive: !!archive || undefined
          }
        });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []);
        }
        else {
          console.error('failed searching for public lots by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for  public lots by a filter due to error:', e);
      }
    },

    async searchOwner({}, text) {
      let allUsers = false;
      let searchOrganizers = false;
      let searchMainOrganizers = false;
      let subordinates = false;

      try {
        if (_.isObject(text)) {
          allUsers = !!text.allUsers;
          searchOrganizers = !!text.organizer;
          searchMainOrganizers = !!text.mainOrganizer;
          subordinates = !!text.subordinates;
          text = text.text;
        }

        const response = await api.get('account/user/auto', {
          params: {
            query: LayoutConverter.en(text),
            query2: LayoutConverter.ru(text),
            pagesize: 100,
            allUsers: allUsers || undefined,
            mainOrg: searchMainOrganizers || undefined,
            org: searchOrganizers || undefined,
            subordinates: subordinates || undefined
          }
        });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: [e.lastName, e.firstName, e.middleName].join(' ')
          }));
        }
        else {
          console.error('failed searching for owner by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for owner by a filter due to error:', e);
      }
    },

    async fetchCategories({}, { parent }) {
      try {
        const response = await api.get(`system/categories/parent${parent ? '/' + parent : ''}`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.name,
            hasChild: e.hasChild
          }));
        }
        else {
          console.error('failed fetching categories:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed fetching categories by due to error:', e);
      }
    },

    async fetchOKEIs({}) {
      try {
        const response = await api.get(`system/okei`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.name
          }));
        }
        else {
          console.error('failed fetching categories:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed fetching categories by due to error:', e);
      }
    },

    async fetchDocuments() {
      try {
        const response = await api.get(`system/documents/Tender`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.name
          }));
        }
        else {
          console.error('failed fetching categories:', {
            status, errorCode
          });
        }
      }
      catch(e) {
        console.error('failed fetching documents by due to error:', e);
      }
    },


    async fetchPossibleCriteria() {
      try {
        const response = await api.get(`/system/criterions/None`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.name,
            type: e.type
          }));
        }
        else {
          console.error('failed fetching categories:', {
            status, errorCode
          });
        }
      }
      catch(e) {
        console.error('failed fetching documents by due to error:', e);
      }
    },

    async fetchFileExtensions({commit, getters}) {
      try {
        const limits = getters.getFilesLimits;
        if (limits.extensions.length > 0) {
          return limits;
        }

        const response = await api.get('system/fileExtensions')
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          commit('setFilesLimits', {
            extensions: result.map(e => e.extension),
            limits: result.reduce((acc, item) => { acc[item.extension] = item.maxSize; return acc; }, {})
          });

          return getters.getFilesLimits;
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch (e) {
        console.error('failed fetching file extensions config', e);
        throw e;
      }
    },

    authForSignature({getters}) {
      //api.get('/signature/auth')
      location.href = `${process.env.VUE_APP_API_URL}/signature/auth/${getters.currentUser.id}`
      // const xhr = new XMLHttpRequest();
      // xhr.open('GET', `/api/signature/auth`, true);
      // //xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
      // // xhr.onload = function() {
      // //   if (xhr.status === 200) {
      // //     if (xhr.responseURL === url) {
      // //       console.log('got what we wanted, hooray!');
      // //     }
      // //     else {
      // //       console.log('boo, we were redirected from', url, 'to', xhr.responseURL);
      // //     }
      // //   }
      // // };
      // xhr.send();
    },

    async initiateSigning({}, {hash, code}) {
      let error;

      try {
        const response = await api.post('/signature', {hash, code});
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return {
            url: result.url,
            id: result.state
          }
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async checkSigning({}, {code}) {
      let error;

      try {
        const response = await api.get(`/signature/${code}/complete`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return {
            status: result.status,
            signature: result.signature
          }
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async authorizeSigning({}, {code, state}) {
      let error;

      try {
        const response = await api.put(`/signature/${state}`, { code });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return {
            url: result.url,
            signingId: result.id
          }
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async authorizeSigningStupid({}, {code, state}) {
      let error;

      try {
        const response = await api.post(`/signature/${state}`, { code });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return {
            url: result.url,
            signingId: result.id
          }
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async downloadRegulations({}, filename) {
      let error;

      try {
        await api.download(`/system/Reglament`, {}, {
          filename: filename + '.pdf'
        });
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async downloadAgreement({}, filename) {
      let error;

      try {
        await api.download(`/system/Soglashenie`, {}, {
          filename: filename + '.pdf'
        });
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async downloadInstruction({}, filename) {
      let error;

      try {
        await api.download(`/system/Instruction`, {}, {
          filename: filename + '.pdf'
        });
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async downloadSignature({}, filename) {
      let error;

      try {
        await api.download(`/system/Ep`, {}, {
          filename: filename + '.pdf'
        });
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async searchOrganizations({}, text) {
      let options = {};

      if (text instanceof Object) {
        options = text;
        text = options.text;
      }

      const params = {
        query: LayoutConverter.en(text),
        query2: LayoutConverter.ru(text),
        pageSize: options.pageSize || 100
      };

      try {
        const response = await api.get('/organization/filter/auto', { params });
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return (result || []).map((e) => ({
            id: e.id,
            name: e.name
          }));
        }
        else {
          console.error('failed searching for organization by a filter:', {
            status, errorCode
          });
        }
      }
      catch (e) {
        console.error('failed searching for organization by a filter due to error:', e);
      }
    },
  }
}
